import { TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const getResources = (lang: string) => tradingGatewayApiClient.resources.getV1ResourcesLocalization(lang);
export const getLanguages = () => tradingGatewayApiClient.resources.getV1ResourcesLanguages();
